import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {AlertBannerService, AlertType} from "../../lib/alert-banner";
import {InsightsService} from "../../services/insights/insights.service";
import { PermissionsService } from '../../services/permissions/permissions.service';
import * as _ from 'lodash';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-performance',
  templateUrl: './performance.component.pug',
  styleUrls: ['./performance.component.scss'],
  standalone: false
})
export class PerformanceComponent implements OnInit, OnChanges {

  @Input() start!: any;
  @Input() end!: any;
  @Input() request!: any;
  @Input() questionnaire!: any;
  @Input() department!: any;
  @Input() filterBy!: any;
  @Input() selectedTab!: 'exits' | 'pulses';
  @Input() pulseDepartments:any;
  OrgPerformText = $localize`Organisational performance`

  perfMetrics: any[] = [];
  perfTrend = [];
  ENT_10363_PULSE_RELAUNCH = false;

  constructor(private insightsService: InsightsService,
              private alertList: AlertBannerService,
              private permissionsService: PermissionsService
             ) {
    this.ENT_10363_PULSE_RELAUNCH = this.permissionsService.isFeatureActivated('ENT-10363-pulse-relaunch');
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.ENT_10363_PULSE_RELAUNCH) {
      this.loadAndSetData();
    } else {
      this.deprecatedLoadAndSetData();
    }
      if (this.pulseDepartments.length === 1) {
        this.OrgPerformText = $localize`Department performance: ${this.pulseDepartments[0].department}`
      }
      else {
        this.OrgPerformText = $localize`Organisational performance`
      }
  }


  private deprecatedLoadAndSetData() {
    this.perfTrend = [];
    this.perfMetrics = [];

    if(this.selectedTab === 'exits') {
      this.insightsService.getPerfAll(this.start, this.end, this.questionnaire, this.filterBy).subscribe(data => {
        this.perfMetrics = data['metrics'];
        this.perfTrend = data['trend'];
      }, error => {
        console.log(error);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      });
    } else {
      // Selected tab is Pulses
      forkJoin({
        trend: this.insightsService.getPulsePerfTrend(this.start, this.end, this.questionnaire, this.filterBy, this.department, this.request),
        overall: this.insightsService.getPulsePerfOverall(this.start, this.end, this.questionnaire, this.filterBy, this.department, this.request)}).subscribe((data: any) => {
        this.perfTrend = {
          ...data.trend,
          start: this.start,
          end: this.end
        };
        this.perfMetrics = data.overall
      }, error => {
        console.log(error);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      });
    }
  }

  private loadAndSetData() {
    this.perfTrend = [];
    this.perfMetrics = [];

    if(this.selectedTab === 'exits') {
      this.insightsService.getPerfAll(this.start, this.end, this.questionnaire, this.filterBy).subscribe(data => {
        this.perfMetrics = Array.isArray(data['metrics']) ? data['metrics'] : [];
        this.perfTrend = data['trend'];
      }, error => {
        console.log(error);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      });
    } else {
      // Selected tab is Pulses
      forkJoin({
        trend: this.insightsService.getPulsePerfTrend(this.start, this.end, this.questionnaire, this.filterBy, this.department, this.request),
        metrics: this.insightsService.getPulseInsightsMetrics(this.start, this.end, this.request, this.department, this.questionnaire)
      }).subscribe((data: any) => {
        this.perfTrend = {
          ...data.trend,
          start: this.start,
          end: this.end
        };
        this.perfMetrics = Array.isArray(data.metrics?.pulse_metrics) ? data.metrics.pulse_metrics : [];
      }, error => {
        console.log(error);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      });
    }
  }

}
